import {rolePermissionCreation,fetchAllRolePermission,getSingleRolePermission,
    rolePermissionModify,permissionDelete,getCombinedRolePermission  } from "../../../api/userApi";

import { getPermissionPending, getPermissionSuccess, getPermissionFail,
   createPermissionPending, createPermissionSuccess, createPermissionFail,
   getSPermissionPending,getSPermissionSuccess,getSPermissionFail,
   modifyPermissionPending,modifyPermissionSuccess,modifyPermissionFail,
   deletePermissionPending,deletePermissionSuccess,deletePermissionFail,
   getCPermissionPending,getCPermissionSuccess,getCPermissionFail,
   getSRPermissionPending,getSRPermissionSuccess,getSRPermissionFail } from "./rolepermissionSlice";

import Swal from "sweetalert2";

export const getRolePermissionById = (id) => async (dispatch) => {

    try {
     //call the api
    dispatch(getSPermissionPending());
    const result = await getSingleRolePermission(id);
   // const userData=JSON.parse(result.user);
 console.log(result);
 //console.log(result);

 
 //console.log('check user profile out if');
    if(result.rolePermissions[0] && result.rolePermissions[0].id){
    console.log('getting permissiion details');
        return dispatch(getSPermissionSuccess(result.rolePermissions));
    }
    dispatch(getSPermissionFail("permission is not found"));
 
   
 } catch (error) {
    // console.log("catch block");
    const err = JSON.parse(JSON.stringify(error.response.data.error));
    //console.log(error);
   // console.log(err.msg);
  
    dispatch(getSPermissionFail(err.msg));
    console.log(error);
 
 }
 }

 export const getAllRolePermission = () => async (dispatch) => {
   try {
       //call the api
       dispatch(getPermissionPending());
       const result = await fetchAllRolePermission();
       //const userData=JSON.parse(result);
       const myJSON = JSON.stringify(result);

       //console.log('allCityData ' + myJSON);
       //console.log('alluserData 1  '+myJSON.user);
       const myObj = JSON.parse(myJSON);
       const permissiondetails = JSON.parse(JSON.stringify(myObj.userpermission));
       //const citydetails1 = JSON.parse(JSON.stringify(permissiondetails));
       
       if (permissiondetails) {
       
           return dispatch(getPermissionSuccess(permissiondetails));
       }
       dispatch(getPermissionFail("Permission is not found"));


   } catch (error) {
      //console.log(error.msg);
       const err = JSON.parse(JSON.stringify(error));
       // console.log(err.message);
        //console.log(JSON.parse(JSON.stringify(error)));
        dispatch(getPermissionFail(err.msg));

   }
}

export const rolePermissionDeletion = (id) => async(dispatch) => {

    try {
        dispatch(deletePermissionPending());
        const result = await permissionDelete(id);
       // console.log("userCreation "+result);
      // console.log("try block");
       //console.log(result.status);
        result.status ==="success" 
        ? dispatch(deletePermissionSuccess("Permission deleted"))
        : dispatch(deletePermissionFail(result.message));
        console.log(result);
        
    } catch (error) {
       // console.log("catch block");
       const err = JSON.parse(JSON.stringify(error.response.data.error));
       // console.log(err.message);
        //console.log(JSON.parse(JSON.stringify(error)));
        dispatch(deletePermissionFail(err.msg));
        console.log(error)
    }
    
}

export const newRolePermissionCreation = (frmDt) => async (dispatch) => {
   
    try {
        dispatch(createPermissionPending());
        const result = await rolePermissionCreation(frmDt);
        //console.log(result.status==="fail");
        result.status === "success"
            ? dispatch(createPermissionSuccess(result.message))
            : dispatch(createPermissionFail(result.message));

           // console.log("CountryCreation "+result);
            // console.log("try block");
           // console.log(result.status);
           // console.log('actions '+result.message);

    } catch (error) {
         console.log(error);
        const err = JSON.parse(JSON.stringify(error.response.data.error));
        Swal.fire(err.msg, '', 'error')
         console.log(error);
    
          dispatch(createPermissionFail());    
       
    }

}
//combined table role permission
export const getCSinglePermission = (id) => async (dispatch) => {
    
 
    try {
     //call the api
    dispatch(getCPermissionPending());
    const result = await getCombinedRolePermission(id);
   // const userData=JSON.parse(result.user);
 console.log('Rolepermission ');
 //console.log(result);
 console.log("Rolepermissionddd",result.rolePermissions);
 
 //console.log('check user profile out if');
    if(result.rolePermissions){
    //console.log('check user profile');
        return dispatch(getCPermissionSuccess(result.rolePermissions));
    }
    dispatch(getCPermissionFail("Permission is not found"));
 
   
 } catch (error) {
    console.log("catch block");
    const err = JSON.parse(JSON.stringify(error.response.data.error));
    console.log(error);
   // console.log(err.msg);
  
    dispatch(getCPermissionFail(err.msg));
 
 }
 }


export const getSRolePermission = () => async (dispatch) => {   
 
    try {
     //call the api
    dispatch(getSRPermissionPending());
    const roleid = localStorage.getItem("accessRoleId");
    const result = await getCombinedRolePermission(roleid);
   // const userData=JSON.parse(result.user);
 console.log('CityData ');
 //console.log(result);
 console.log(result);
 
 //console.log('check user profile out if');
 if(result.rolePermissions[0] && result.rolePermissions[0].id){
    //console.log('check user profile');
    return dispatch(getSRPermissionSuccess(result.rolePermissions));
    }
    dispatch(getSRPermissionFail("aaaa is not found"));
   
 } catch (error) {
    // console.log("catch block");
    const err = JSON.parse(JSON.stringify(error.response.data.error));
    //console.log(error);
   // console.log(err.msg);
  
    dispatch(getSRPermissionFail(err.msg));
 
 }
    
 
 }


export const rolePermissionModification = (frmDt) => async (dispatch) => {
   
    try {
        dispatch(modifyPermissionPending());
        const result = await rolePermissionModify(frmDt);
        result.status === "success"
            ? dispatch(modifyPermissionSuccess(result))
            : dispatch(modifyPermissionFail(result));

    } catch (error) {
        // console.log("catch block");
        const err = JSON.parse(JSON.stringify(error.response.data.error));
        console.log(err);
        Swal.fire(err.msg, '', 'error')
        dispatch(modifyPermissionFail(err.msg));
    }

}
